import { ComponentChild, h, JSX } from 'preact'
import { common } from '../../preact-components/common'
import TitleInput from '../../preact-components/title-input/TitleInput'
import { CustomButton } from '../header'
import OverviewSwitcher from '../ui-components/OverviewSwitcher'
import BetaBadge from '../ui-components/BetaBadge'

interface Props {
  type: string
  isCustomView: boolean
  title: string
  isBeta?: boolean
  onTitleChanged: (title: string) => void
  customButtons?: Array<CustomButton | ComponentChild>
  customViewActions?: JSX.Element
  titleLinks?: JSX.Element
}

const Header = (
  {
    isCustomView,
    title,
    onTitleChanged,
    customButtons,
    isBeta = false,
    customViewActions,
    titleLinks
  }: Props) => {
  return (
    <div>
      <div className='control-header'>
        {isCustomView
          ? <TitleInput title={title} onTitleChanged={onTitleChanged} />
          : <h2 className='control-header__title'>{title}{titleLinks && titleLinks}{common.isModuleActive('moderationOverviewBetaDefault') && <OverviewSwitcher />}{isBeta && <BetaBadge />}</h2>}
        {customViewActions}
        {customButtons && <div className='control-header__action-buttons'>{customButtons}</div>}
      </div>
    </div>
  )
}

export default Header
